import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { ListTable } from '@components/table';
import { Tag } from '@components/common';
import { COLORS } from '@theme/styles';
import API from '@utils/api';
import Cookies from 'js-cookie';
import { AppConfig } from '@utils/config';
import { formatDate } from '@utils/date';
import history from '@utils/history';

const CLIENT_PAGE_SIZES = [25, 50, 100, 250];

const filterDefinitions = [
  {
    key: 'createdAt',
    component: 'DateSelect',
    width: 4
  },
  {
    key: 'userID1',
    component: 'NameSearch',
    fetchAPI: API.fetchClients,
    fetchKey: 'email',
    dataField: 'members',
    valueKey: 'userID',
    labelKey: 'email',
    label: 'Client Email',
    width: 4
  },
  {
    key: 'userID2',
    component: 'NameSearch',
    fetchAPI: API.fetchClients,
    fetchKey: 'phone',
    dataField: 'members',
    valueKey: 'userID',
    labelKey: 'phone',
    label: 'Client Phone',
    width: 4
  },
  {
    key: 'userID',
    component: 'NameSearch',
    fetchAPI: API.fetchClients,
    dataField: 'members',
    valueKey: 'userID',
    label: 'Client Name',
    width: 4,
    optionExtractor: item => ({
      text: item.firstName + ' ' + item.lastName,
      value: item.userID
    })
  },
  {
    key: 'propertyID',
    component: 'NameSearch',
    fetchAPI: API.fetchProperties,
    dataField: 'properties',
    valueKey: 'propertyID',
    label: 'Property Name',
    width: 4
  },
  {
    key: 'propertyID1',
    component: 'NameSearch',
    fetchAPI: API.fetchProperties,
    dataField: 'properties',
    valueKey: 'propertyID1',
    fetchKey: 'unitNumber',
    label: 'Unit number',
    width: 4
  }
];

function ClientsTable() {
  const hanelViewClient = async client => {
    const { userID } = client;

    history.push(`/clients/${userID}`);
  };

  const handleLoginAsClient = async client => {
    const { userID } = client;
    const { result } = await API.getImpersonate(userID);
    const { authToken, refreshToken } = result;
    Cookies.set('authToken', authToken, { domain: AppConfig.DOMAIN });
    Cookies.set('refreshToken', refreshToken, { domain: AppConfig.DOMAIN });

    const win = window.open(AppConfig.WEB_APP_URL, '_blank');
    win.focus();
  };

  const dataColumns = [
    {
      title: 'Date Created',
      dataIndex: 'createdAt',
      render: value => <>{formatDate(value)}</>,
      sorter: true
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (value, row) => (
        <>
          {row.firstName} {row.lastName}{' '}
        </>
      ),
      sorter: true
    },
    {
      title: 'VIP',
      dataIndex: 'isVIP',
      render: value => (value ? <Tag content="VIP" color={COLORS.cyan} /> : ''),
      sorter: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: true
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      sorter: true
    },
    {
      title: 'Region',
      dataIndex: 'regionName',
      sorter: true
    },
    {
      title: 'Building',
      dataIndex: 'buildingName',
      sorter: true
    },
    {
      title: 'Property Name',
      dataIndex: 'propertyName',
      render: (value, row) => (
        <Link to={`/properties/${row.propertyID}`}>{value}</Link>
      )
    },
    {
      title: 'No. of Beds',
      dataIndex: 'bedroomsCount',
      sorter: true
    },
    {
      title: 'Unit No.',
      dataIndex: 'unitNumber',
      sorter: true
    },
    {
      title: 'Completed Services',
      dataIndex: 'totalCompletedServices',
      sorter: true
    },
    {
      title: 'Pets',
      dataIndex: 'hasPets',
      render: value => (value ? 'Yes' : 'No'),
      sorter: true
    },
    {
      title: 'Key Release',
      dataIndex: 'isKeyReleaseSigned',
      render: value => (value ? 'Signed' : 'Not Signed'),
      sorter: true
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, row) => (
        <div>
          <Button
            type="primary"
            style={{ marginBottom: 5 }}
            onClick={() => {
              handleLoginAsClient(row);
            }}
          >
            Login as Client
          </Button>
          <Button
            type="primary"
            onClick={() => {
              hanelViewClient(row);
            }}
          >
            View Details
          </Button>
        </div>
      )
    }
  ];

  return (
    <div className="table-view">
      <ListTable
        columns={dataColumns}
        dataId="userID"
        filterDefinitions={filterDefinitions}
        pageSizes={CLIENT_PAGE_SIZES}
        fetchAPI={API.fetchClients}
        dataFields="members"
        defaultFilter={{}}
        defaultPageSize={100}
      />
    </div>
  );
}

export default ClientsTable;
